/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

import { Types } from '@scorenco/core';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetWidgetQueryVariables = Types.Exact<{
  widgetId: Types.Scalars['Int']['input'];
  cacheTTL?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetWidgetQuery = {
  __typename: 'query_root';
  widgets_widget_by_pk?:
    | {
        __typename: 'widgets_widget';
        id: number;
        club_id?: number | undefined;
        category?: string | undefined;
        title?: string | undefined;
        settings?:
          | {
              __typename: 'widgets_club_settings';
              id: number;
              background_color?: string | undefined;
              font_color?: string | undefined;
              color?: string | undefined;
            }
          | undefined;
        widget_teams?:
          | Array<{
              __typename: 'widgets_widget_has_team';
              id: number;
              team_detail?:
                | Array<{
                    __typename: 'teams_team_detail';
                    id: number;
                    team_id?: number | undefined;
                    name_in_club?: string | undefined;
                    name_in_competition?: string | undefined;
                    logo?: string | undefined;
                    category?: string | undefined;
                  }>
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type GetClubInfosQueryVariables = Types.Exact<{
  clubId: Types.Scalars['Int']['input'];
  cacheTTL?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetClubInfosQuery = {
  __typename: 'query_root';
  clubs_club_by_pk?:
    | {
        __typename: 'clubs_club';
        id: number;
        name?: string | undefined;
        logo?: string | undefined;
        color_primary?: string | undefined;
        color_secondary?: string | undefined;
        sport?:
          | { __typename: 'clubs_sport'; name?: string | undefined }
          | undefined;
      }
    | undefined;
};

export type GetPreviousAndNextEventsQueryVariables = Types.Exact<{
  teamId: Types.Scalars['Int']['input'];
  cacheTTL?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetPreviousAndNextEventsQuery = {
  __typename: 'query_root';
  previousEvent?:
    | Array<{
        __typename: 'competitions_event_detail';
        old_url?: string | undefined;
        id: number;
        status?: string | undefined;
        date?: any | undefined;
        time?: any | undefined;
        teams?: any | undefined;
        level_name?: string | undefined;
        round?:
          | {
              __typename: 'competitions_round';
              id: number;
              name?: string | undefined;
              competition?:
                | {
                    __typename: 'competitions_competition';
                    id: number;
                    name?: string | undefined;
                    slug?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
      }>
    | undefined;
  nextEvent?:
    | Array<{
        __typename: 'competitions_event_detail';
        old_url?: string | undefined;
        id: number;
        status?: string | undefined;
        date?: any | undefined;
        time?: any | undefined;
        teams?: any | undefined;
        level_name?: string | undefined;
        round?:
          | {
              __typename: 'competitions_round';
              id: number;
              name?: string | undefined;
              competition?:
                | {
                    __typename: 'competitions_competition';
                    id: number;
                    name?: string | undefined;
                    slug?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
      }>
    | undefined;
};

export const GetWidgetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWidget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'widgetId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cacheTTL' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '600' },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: {
                kind: 'Variable',
                name: { kind: 'Name', value: 'cacheTTL' },
              },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'widgets_widget_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'widgetId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'club_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'background_color' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'font_color' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'widget_teams' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'team' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'rank' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team_detail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'team_id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name_in_club' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'name_in_competition',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWidgetQuery, GetWidgetQueryVariables>;
export const GetClubInfosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetClubInfos' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clubId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cacheTTL' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '120' },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: {
                kind: 'Variable',
                name: { kind: 'Name', value: 'cacheTTL' },
              },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clubs_club_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'clubId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'color_primary' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'color_secondary' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sport' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubInfosQuery, GetClubInfosQueryVariables>;
export const GetPreviousAndNextEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPreviousAndNextEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cacheTTL' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '60' },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: {
                kind: 'Variable',
                name: { kind: 'Name', value: 'cacheTTL' },
              },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'previousEvent' },
            name: {
              kind: 'Name',
              value: 'competitions_event_detail_by_team_id',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'args' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'date_filter' },
                      value: { kind: 'IntValue', value: '-1' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EventCard' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'old_url' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'nextEvent' },
            name: {
              kind: 'Name',
              value: 'competitions_event_detail_by_team_id',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'args' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'date_filter' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EventCard' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'old_url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'competitions_event_detail' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'round' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'competition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'teams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level_name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPreviousAndNextEventsQuery,
  GetPreviousAndNextEventsQueryVariables
>;
